import { render } from "./AddAgentModal.vue?vue&type=template&id=f643fbae&ts=true"
import script from "./AddAgentModal.vue?vue&type=script&lang=ts"
export * from "./AddAgentModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__